// extracted by mini-css-extract-plugin
module.exports = {"main_wrapper":"style_main_wrapper__K2BPd","rutube":"style_rutube__26pVQ"};